export interface IUpdateLessonTagRequest {
    lessonId: string;
    newTag: string;
    tagType: LessonTagType;
}

export enum LessonTagType {
    A,
    B
}